import React, { Component } from "react";
import ReactTable from "react-table";
import { Button } from "reactstrap";
import "react-table/react-table.css";
import CreateAgentInvoiceForm from "./createAgentInvoiceForm";
//import AgentService from "../services";

const columns = [
  {
    Header:"Agent id",
    accessor: "agent_id",
    width: 90,
    // String-based value accessors!
    Cell: props => (
      <span className="d-flex justify-content-center">{props.value}</span>
    )
  },
  {
    Header:"business name",
    accessor: "business_name", // String-based value accessors!
    Cell: props => (
      <span className="d-flex justify-content-center">{props.value}</span>
    )
  },
  {
    Header: "agent status",
    accessor: "agent_status_name",
    width: 140,
    // String-based value accessors!
    Cell: props => (
      <span className="d-flex justify-content-center">{props.value}</span>
    )
  },
  {
    Header:"proprieter name",
    accessor: "proprietor_name", // String-based value accessors!
    Cell: props => (
      <span className="d-flex justify-content-center">{props.value}</span>
    )
  },
  {
    Header:"city name",
    accessor: "city_name",
    width: 100,
    // String-based value accessors!
    Cell: props => (
      <span className="d-flex justify-content-center">{props.value}</span>
    )
  },
 
  {
    Header: "آپریشن ", // Custom header components!
    accessor: "operation",
    width: 90,
    Cell: props => (
      <div className="d-flex justify-content-center">{props.value}</div>
    )
  }
];

export default class AgentInvoiceList extends Component {
  

  state = {
    updateUserModal: false,
    agentId: ""
  };

  componentDidMount() {
   // this.getUsers();
  }

  toggle = () => {
  
  
    this.setState(prevState => ({
      updateUserModal: !prevState.updateUserModal
    }));
  };

  showUpdateModal = id => {
    let param=false;
    this.setState({agentId: id }, () => {
    this.toggle(param);
    });
  };
  
  getUsers = ()=>{
    this.props.getUsers();
  }
  render() {
    let { data } = this.props;
    //console.log("data",data);
    data.forEach(element => {
      element["operation"] = (
        <span>
          <Button
            onClick={() => {
              this.showUpdateModal(element["agent_id"]);
            }}
            color="primary"
            className="m-1"
            // disabled={}
          >
            <i className="fas fa-file-invoice-dollar"></i>
          </Button>
          {/* <Button color="danger" className="m-1">
            <i class="fas fa-trash" aria-hidden="true"></i>
          </Button> */}
        </span>
      );
    });

    return (
      <div>
        <ReactTable
          data={data}
          columns={columns}
          showPaginationTop={true}
          showPaginationBottom={false}
        />
        
        {this.state.agentId !== "" ? (
          <CreateAgentInvoiceForm
            modal={this.state.updateUserModal}
            toggle={(param) => this.toggle(param)}
            agentId={this.state.agentId}
            getUsers={this.getUsers}
          />
          
        ) : null}
      </div>
    );
  }
}
